import { DEFAULT_STORAGE_URL } from 'constants/progressStorage';
import getImageResizeUrl from 'components/mixins/images';

export const getFonts = state => state.settings.template && state.settings.template.fonts;

export const getColors = state =>
  state.settings.template && state.settings.template.branding.colors;

export const getLogo = state =>
  state.settings.template && getImageResizeUrl(state.settings.template.branding.mainLogo, 400, 160);

export const getAlternativeLogo = state =>
  state.settings.template &&
  getImageResizeUrl(state.settings.template.branding.alternativeLogo, 720, 400);

export const isMainLogoShown = state =>
  state.settings.template && state.settings.template.branding.allowToShowMainLogo;

export const getBackground = state => state.settings.template && state.settings.template.background;

export const getTranslations = state => state.settings.translations;

export const isResultsTrackingEnabled = state =>
  state.settings.template && state.settings.template.results.resultsTracking.enabled;

export const getXapiSettings = state =>
  state.settings.template && state.settings.template.results.xApi;

export const isScoringOfContentPagesAllowed = state =>
  state.settings.template.results.allowScoringOfContentPages.enabled;

export const getPublishSettings = state => state.settings.template && state.settings.publish;

export const isCrossDeviceSavingEnabled = state =>
  state.settings.template && state.settings.template.general.saveProgressCrossDevice.enabled;

export const isNpsEnabled = state =>
  state.settings.template &&
  state.settings.template.general.conductLearnerSatisfactionSurvey.enabled;

export const isAccessLimited = state =>
  (state.settings.publish &&
    state.settings.publish.accessLimitation &&
    state.settings.publish.accessLimitation.enabled) ||
  false;

export const isTrackingEnabled = state =>
  isCrossDeviceSavingEnabled(state) ||
  isResultsTrackingEnabled(state) ||
  isNpsEnabled(state) ||
  isAccessLimited(state);

export const isLoginViaSocialMediaEnabled = state =>
  state.settings.template && state.settings.template.general.loginViaSocialMedia.enabled;

export const isScormMode = state =>
  state.settings.template && state.settings.publishMode && state.settings.publishMode.isScorm;
export const isPreviewMode = state =>
  state.settings.template && state.settings.publishMode && state.settings.publishMode.isPreview;
export const isReviewMode = state =>
  state.settings.template && state.settings.publishMode && state.settings.publishMode.isReview;
export const isPublishMode = state =>
  !(isScormMode(state) || isPreviewMode(state) || isReviewMode(state));

export const getStorageUrl = state =>
  state.settings.publish && state.settings.publish.progressStorageUrl
    ? `//${state.settings.publish.progressStorageUrl}`
    : DEFAULT_STORAGE_URL;

export const getAllowedUsers = state =>
  isAccessLimited(state) ? state.settings.publish.accessLimitation.allowedUsers : [];

export const getQuestionShortIds = state =>
  isScormMode(state) ? state.settings.publish.questionShortIds : [];

export const getSelectedLanguage = state => state.settings.template.languages.selected;

export const isAllowedDownloadCertificate = state =>
  state.settings.template &&
  state.settings.template.general.allowUsersToDownloadCertificates.enabled;
